module.exports = __webpack_public_path__ + "video/1200_HC_2023_Social_Media.61a679e9.vtt";